import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {

  private isLoggedIn: Observable<boolean>;

  menuItems = [
    {
      id: '1',
      name: 'Setup',
      path: '',
      items: [
        {
          id: '1_1',
          name: 'Connections',
          routerLink: '/connections'
        },
        {
          id: '1_2',
          name: 'Classifications',
          routerLink: '/classificationCategories'
        }
      ]
    }
  ];

  // menuItems = [
  //   { name: 'Connections', path: '/connections' },
  //   { name: 'Classification Categories', path: '/classificationCategories' },
  //   { name: 'Classify', path: '/classification' }
  //   // { name: 'Classify Report', path: '/classify/classifyReport' }
  // ];

  constructor(private router: Router, private authService: AuthService) {
    this.isLoggedIn = authService.isLoggedIn();
  }

  ngOnInit() {
  }

  logout() {
    this.authService.logout();
  }

  private menuItemClick(e: any): void {
    if (e.itemData.routerLink)
      this.router.navigate([e.itemData.routerLink]);
  }

}
